// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rillaboom_gmax: PokeData = {
  "id": 10209,
  "name": "rillaboom-gmax",
  "height": 280,
  "weight": 10000,
  "base_experience": 265,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [],
  "moves": [
    "razor-leaf",
    "frenzy-plant",
    "energy-ball",
    "solar-beam",
    "branch-poke",
    "wood-hammer",
    "aromatherapy",
    "overgrowth",
    "bullet-seed",
    "leaf-tornado"
  ],
  "evolution_chain": {
    "id": 430,
    "item": null,
    "species": [
      {
        "name": "grookey",
        "order": 810,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "thwackey",
        "order": 811,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 810,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "rillaboom",
        "order": 812,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 811,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 113,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": true,
  "regional_variant": null
} as const;
